import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowPathClockwiseOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M18 5.9 13.1 1l-1.272 1.273L14.555 5H12c-6.75 0-9 4.5-9 9s2.25 9 9 9 9-4.5 9-9h-1.8c0 1.983-.5 3.772-1.552 5.035C16.644 20.24 14.942 21.2 12 21.2s-4.644-.96-5.648-2.165C5.299 17.772 4.8 15.983 4.8 14s.5-3.772 1.552-5.035C7.356 7.76 9.058 6.8 12 6.8h2.554l-2.727 2.727L13.1 10.8z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ArrowPathClockwiseOutlinedSize24Glyph.displayName = 'ArrowPathClockwiseOutlinedSize24Glyph';
